import {getGtmProductsList} from './getGtmProductsList';

export const gtmProductListView = (element, title) => {
    const collectionMain = element;
    const productItems = getGtmProductsList(collectionMain);

    if(productItems.length === 0) {
        return;
    }

    window.dataLayer.push({
        'event': 'ec.product_list_view',
        'ecommerce': {
            'listName': title,
            'products': productItems,
        },
        '_clear': true,
    });
};
